var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('button',{staticClass:"loader-close-btn",on:{"click":_vm.hide}},[_vm._v("X")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }